var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<div ng-include=\"'genericmanager.html'\"></div>\n<div ng-include=\"'mastrodettagliov2.html'\"></div>";
var id1="modalitapagamenti.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;